import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { useTranslation } from 'react-i18next';

import { useEmspBoEmspUserOcpiTokenContext } from '../../emsp-bo-emsp-user.context';

export const EmspBoEmspUserOcpiTokenDeleteFormStep1Controller =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    const { t } = useTranslation();
    const ocpiToken = useEmspBoEmspUserOcpiTokenContext();

    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <>
        <Text bold>
          {t('$.emsp-bo-emsp-user-ocpi-token-delete.step-1.confirm', {
            ocpiContractId: ocpiToken.ocpiContractId,
          })}
        </Text>
        <Text italic>
          {t('$.emsp-bo-emsp-user-ocpi-token-delete.step-1.warning')}
        </Text>
      </>
    );
  };
